import { createAction, props } from '@ngrx/store';
export const addFundChartCalc = createAction('[Fund Chart] Add Calc', props());
export const addFundChartCalcs = createAction('[Fund Chart] Add Calcs', props());
export const toggleFundChartCalc = createAction('[Fund Chart] Toggle Calc', props());
export const removeFundChartCalc = createAction('[Fund Chart] Remove Calc', props());
export const setFundChartCalcs = createAction('[Fund Chart] Set Calcs', props());
